import InboxIcon from '@mui/icons-material/MoveToInbox';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

const PREFIX = 'MenuDrawer';

const classes = {
  drawerList: `${PREFIX}-drawerList`
};

const Root = styled('div')({
  [`& .${classes.drawerList}`]: {
    width: '320px'
  }
});

interface MenuItem {
  name: string;
  link: string;
}

interface MenuDrawerProps {
  title: string;
  menuItems: MenuItem[];
  icon: JSX.Element;
}

export default function MenuDrawer({ title, menuItems, icon }: MenuDrawerProps) {
  const [open, setOpen] = React.useState(false);

  function handleDrawerOpen() {
    setOpen(true);
  }

  function handleDrawerClose() {
    setOpen(false);
  }

  return (
    <Root style={{ paddingLeft: '12px' }}>
      <IconButton
        edge="start"
        color="inherit"
        aria-label="menu"
        onClick={handleDrawerOpen}
        data-testid="button-drawer"
        size="large"
      >
        {icon}
      </IconButton>

      <Drawer anchor="left" open={open} onClose={handleDrawerClose} data-testid="menu-drawer-root">
        <div role="presentation">
          <List className={classes.drawerList}>
            <ListItem>
              <Typography variant="h6">{title}</Typography>
            </ListItem>
            <Divider />
            {menuItems.map(item => (
              <RouterLink
                key={item.name}
                color="inherit"
                to={item.link}
                onClick={handleDrawerClose}
                data-testid={item.name}
              >
                <ListItem button>
                  <ListItemIcon>
                    <InboxIcon />
                  </ListItemIcon>
                  <ListItemText
                    disableTypography
                    primary={<Typography variant="body2">{item.name}</Typography>}
                  />
                </ListItem>
              </RouterLink>
            ))}
          </List>
        </div>
      </Drawer>
    </Root>
  );
}
